import React from "react";
import Social from "../Social";
import Services from "../service/ServiceAnimation";
import Awards from "../award/AwardsAnimation";

const About = () => {
  return (
    <>
      <section id="about" className="section theme-light dark-bg">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div
              className="col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <div className="about-me">
                <div className="img">
                  <div className="img-in">
                    <img src="img/about/full-stack-engineer-spokane.jpg" alt="Ernest Mena Full Stack Engineer" />
                  </div>

                  <Social />

                  {/* End social icon */}
                </div>
                {/* End img */}
                <div className="info">
                  <p>Full-stack Engineer</p>
                  <h3>Ernest Mena</h3>
                </div>
                {/* End info */}
              </div>
              {/* End about-me */}
            </div>
            {/* End col */}

            <div
              className="col-lg-7 ml-auto"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="200"
            >
              <div className="about-info">
                <div className="title">
                  <h3>Biography</h3>
                </div>
                <div className="about-text">
                  <p>
                    I'm a career Full-stack engineer with over 10 years of development experience.
                    Originally from California, I am now located in the northwest in the beautiful city of Spokane. I bring lightweight solutions, out of the box thinking and a leadership mindset make development precise, reliable and efficient.
                  </p>
                  <p>
                    Development, by far, is the most rapidly evolving industry making it difficult to stay on top. Knowing the industry helps when deciding which next piece of tech is here to stay.
                  </p>
                  <p>Keep Learning. Stay Positive. Remain Productive.</p>
                </div>
                <div className="info-list">
                  <div className="row">
                    <div className="col-sm-6">
                      <ul>
                        <li>
                          <label>Name: </label>
                          <span>Ernest Mena</span>
                        </li>
                        <li>
                          <label>Location: </label>
                          <span>Spokane Washington</span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-sm-6">
                      <ul>
{/*                        <li>
                          <label>Email: </label>
                          <span>ernestmena@gmail.com</span>
                        </li>*/}
                        <li>
                          <label>Freelance: </label>
                          <span>Available</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End col */}
          </div>

          {/* separated */}

          <div
            className="separated"
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + "img/border-dark.png"
              })`,
            }}
          ></div>

          {/* End separated */}
          <div className="title">
            <h3>What I do?</h3>
          </div>

          <Services />

          {/* End .row */}

          {/* separated */}
          <div
            className="separated"
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + "img/border-dark.png"
              })`,
            }}
          ></div>
          {/* End separated */}

          <div className="title">
            <h3>Awards.</h3>
          </div>

          <Awards />
          {/* End Awards */}

        </div>
      </section>
    </>
  );
};

export default About;
